module.exports = __webpack_public_path__ + "img/friend.18f36e54.png";